import React from 'react';
import styles from './PaymentInvoices.module.css';
import { fmtDateShort, fmtCurr } from './helpers';

const RunCycleModal = ({
  isOpen,
  fromDate,
  toDate,
  invoiceCount = 0,
  netPayout = 0,
  paymentDate,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalBg} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className={styles.modalBox} style={{ width: 480, textAlign: 'center' }}>
        <div className={styles.runIcon}>⚡</div>
        <div className={styles.runTitle}>Run This Week&apos;s Invoice Cycle</div>
        <div className={styles.runBody}>
          This will generate <strong>{invoiceCount.toLocaleString()} invoices</strong> for the period{' '}
          <strong>{fmtDateShort(fromDate)} – {fmtDateShort(toDate)}</strong>.<br />
          PDFs and CSVs will be uploaded to S3 and emailed to each venue&apos;s finance contact.<br /><br />
          Estimated net payout: <strong style={{ color: 'var(--gr)' }}>{fmtCurr(netPayout)}</strong>
          {paymentDate && <> · Due: <strong>{fmtDateShort(paymentDate)}</strong></>}
        </div>
        <div className={styles.modalActions}>
          <button className={`${styles.btn} ${styles.btnSecondary}`} style={{ flex: 1, padding: 12, justifyContent: 'center' }} onClick={onClose}>Cancel</button>
          <button className={`${styles.btn} ${styles.btnPrimary}`} style={{ flex: 2, padding: 12, justifyContent: 'center' }} onClick={onConfirm}>✓ Confirm &amp; Run</button>
        </div>
      </div>
    </div>
  );
};

export default RunCycleModal;
